import isModal from './isModal';
import toUrl from './toUrl';
import Cookies from 'cookies-js';


export default function social_target(app) {
  var url = location.href;
  var purl = Cookies.get('purl');

  if (isModal() && purl) {
    if (Cookies.get('purl_only') === "1") {
      url = purl;
    } else {
      var params = {
        // se c'è il product_id devo aprire l'applicativo product
        product_id: app.product ? app.product.id : null,
        // se non c'è un product devo aprire l'applicativo user (per il sito madai.co.uk/italia)
        user: !app.product ? true : null
      };
      url = toUrl(purl, params);
    }
  }

  // fix paypal redirect
  if (url.indexOf('#') !== -1) {
    url = url.substring(0, url.indexOf('#'));
  }

  return url;
}



/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/domain/social_target.js
 **/